import { render } from "./CheckoutKoView.vue?vue&type=template&id=8a50309a&ts=true"
import script from "./CheckoutKoView.vue?vue&type=script&lang=ts"
export * from "./CheckoutKoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__